export default {
  'menu.welcome': 'Bem-vindo',
  'menu.more-blocks': 'Mais Blocos',
  'menu.home': 'Início',
  'menu.console': 'Admin',
  'menu.console.sub-page': 'Sub-Página',
  'menu.login': 'Entrar',
  'menu.register': 'Registrar',
  'menu.register-result': 'Resultado do Registro',
  'menu.dashboard': 'Painel',
  'menu.dashboard.analysis': 'Análise',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Local de Trabalho',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Formulário',
  'menu.form.basic-form': 'Formulário Básico',
  'menu.form.step-form': 'Formulário de Etapas',
  'menu.form.step-form.info': 'Formulário de Etapas(escrever informações de transferência)',
  'menu.form.step-form.confirm': 'Formulário de Etapas(confirmar informações de transferência)',
  'menu.form.step-form.result': 'Formulário de Etapas(concluído)',
  'menu.form.advanced-form': 'Formulário Avançado',
  'menu.list': 'Lista',
  'menu.list.table-list': 'Tabela de Pesquisa',
  'menu.list.basic-list': 'Lista Básica',
  'menu.list.card-list': 'Lista de Cartões',
  'menu.list.search-list': 'Lista de Pesquisa',
  'menu.list.search-list.articles': 'Lista de Pesquisa(artigos)',
  'menu.list.search-list.projects': 'Lista de Pesquisa(projetos)',
  'menu.list.search-list.applications': 'Lista de Pesquisa(aplicações)',
  'menu.profile': 'Perfil',
  'menu.profile.basic': 'Perfil Básico',
  'menu.profile.advanced': 'Perfil Avançado',
  'menu.result': 'Resultado',
  'menu.result.success': 'Sucesso',
  'menu.result.fail': 'Falha',
  'menu.exception': 'Exceção',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Disparar',
  'menu.account': 'Conta',
  'menu.account.center': 'Centro da Conta',
  'menu.account.settings': 'Configurações da Conta',
  'menu.account.trigger': 'Erro de Disparo',
  'menu.account.logout': 'Sair',
  'menu.account.profile': 'Perfil',
  'menu.console.agents': 'agentes',
  'menu.console.agentDevice': 'dispositivoAgente',
  'menu.console.devices': 'dispositivos',
  'menu.console.speakers': 'Reconhecimento de Locutor',
  'menu.console.voiceClone': 'Clonagem de Voz',
  'menu.console.settings': 'Configurações pessoais',
  'menu.admin': 'Admin',
  'menu.admin.dashboard': 'Painel',
  'menu.admin.settings': 'Configurações',
  'menu.admin.providers': 'Provedores de Modelo',
  'menu.admin.unbindDevice': 'Desvinculação de Dispositivo',
  'menu.admin.userManage': 'Gerenciamento de Usuários',
  'menu.admin.systemConfig': 'Configuração do Sistema',
  'menu.admin.whiteList': 'Lista Branca',
  'menu.admin.opsManage': 'Operações',
  'menu.admin.recorderManage': 'Gerenciamento de Gravador',
  'menu.admin.deviceManage': 'Gerenciamento de Dispositivos',

  'menu.console.agentSetting': 'Configurações do Agente',
};
